// extracted by mini-css-extract-plugin
export default {"title":"Header_title__l+wMf","subTitle":"Header_subTitle__xi3UR"};